// extracted by mini-css-extract-plugin
export var centerText = "_67-8";
export var container = "_67-0";
export var doughnutContainer = "_67-7";
export var legend = "_67-a";
export var legendItemColorDisplay = "_67-b";
export var legendItemLabel = "_67-d";
export var legendItemValue = "_67-c";
export var lg = "_67-5";
export var maxWidth = "_67-9";
export var md = "_67-4";
export var responsive = "_67-6";
export var sm = "_67-3";
export var xs = "_67-2";
export var xxs = "_67-1";